module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcleg0-747cd2cf2ba78a4c8eebd9a1b78f3567.jpg";